import { SharedLinkFetchState } from '@hook/useSharedLinkResource';
import React from 'react';

type SharedLinkStateProps = {
    state: SharedLinkFetchState;
    onRetry?: () => void;
    onSecondaryAction?: () => void;
    loadingText?: string;
    notFoundText?: string;
    errorText?: string;
    retryText?: string;
    secondaryActionText?: string;
};

function SharedLinkState({
    state,
    onRetry,
    onSecondaryAction,
    loadingText = 'Loading...',
    notFoundText = 'The requested information is not available.',
    errorText = "We couldn't load this information. Please check your connection and try again.",
    retryText = 'Try again',
    secondaryActionText = 'Explore more services'
}: SharedLinkStateProps) {
    if (state === 'idle' || state === 'ready') return null;

    const isLoading = state === 'loading';
    const isError = state === 'error';
    const message = isLoading ? loadingText : state === 'notFound' ? notFoundText : errorText;
    const title = isLoading
        ? 'Just a moment'
        : isError
            ? 'Something went wrong'
            : 'Information unavailable';

    return (
        <section className={`shared-link-state shared-link-state--${state}`} role={isError ? 'alert' : 'status'}>
            <div className="shared-link-state__card">
                {isLoading ? (
                    <div className="shared-link-state__icon" aria-hidden="true">
                        <span className="shared-link-state__spinner" />
                    </div>
                ) : (
                    <img
                        className="shared-link-state__illustration"
                        src="/assets/Icons/page_not_found.png"
                        alt=""
                        aria-hidden="true"
                    />
                )}
                <h2 className="shared-link-state__title">{title}</h2>
                <p className="shared-link-state__message">{message}</p>
                <div className="shared-link-state__actions">
                    {!isLoading && onRetry && (
                        <button className="shared-link-state__button shared-link-state__button--primary" type="button" onClick={onRetry}>
                            {retryText}
                        </button>
                    )}
                    {!isLoading && onSecondaryAction && (
                        <button className="shared-link-state__button shared-link-state__button--secondary" type="button" onClick={onSecondaryAction}>
                            {secondaryActionText}
                        </button>
                    )}
                </div>
            </div>
        </section>
    );
}

export default SharedLinkState;
